/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {useNavigate } from "react-router-dom";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

import HeaderDark from "../../../common/header/HeaderDark";
import FooterOne from "../../../common/footer/FooterOne";

import banner from "../../../../src/app/assets/images/mob&design dev-media/banner.mp4";
import cutout1 from "../../../../src/app/assets/images/mob&design dev-media/cutout1.mp4";
import book from "../../../app/assets/images/book1.png";

// brand logo imports

import c1 from "../../../app/assets/images/banner/c1.jpg";
import c2 from "../../../app/assets/images/banner/c2.jpg";
import c3 from "../../../app/assets/images/banner/c3.jpg";
import c4 from "../../../app/assets/images/banner/c4.jpg";
import c5 from "../../../app/assets/images/banner/c5.jpg";
import c6 from "../../../app/assets/images/banner/c6.jpg";
import c7 from "../../../app/assets/images/banner/c7.jpg";
import c8 from "../../../app/assets/images/banner/c8.jpg";
import c9 from "../../../app/assets/images/banner/c9.jpg";
import c10 from "../../../app/assets/images/banner/c10.jpg";
import c11 from "../../../app/assets/images/banner/c11.jpg";
import c12 from "../../../app/assets/images/banner/c12.jpg";
import c13 from "../../../app/assets/images/banner/c13.jpg";
import c14 from "../../../app/assets/images/banner/c14.jpg";
import c15 from "../../../app/assets/images/banner/c15.jpg";
import c16 from "../../../app/assets/images/banner/c16.jpg";
import c17 from "../../../app/assets/images/banner/c17.jpg";
import c19 from "../../../app/assets/images/banner/c19.jpg";
import c20 from "../../../app/assets/images/banner/c20.jpg";
import c21 from "../../../app/assets/images/banner/c21.png";
import c22 from "../../../app/assets/images/banner/c22.png";
import c23 from "../../../app/assets/images/banner/c23.png";
import c24 from "../../../app/assets/images/banner/c24.png";
import c25 from "../../../app/assets/images/banner/c25.png";
import c26 from "../../../app/assets/images/banner/c26.png";
import c27 from "../../../app/assets/images/banner/c27.png";
import c28 from "../../../app/assets/images/banner/c28.png";
import c29 from "../../../app/assets/images/banner/c29.png";
import c30 from "../../../app/assets/images/banner/c30.png";
import c31 from "../../../app/assets/images/banner/c31.png";

// icons import

import icon1 from "../../../app/assets/images/mob&design dev-media/icon1.png";
import icon2 from "../../../app/assets/images/mob&design dev-media/icon2.png";
import icon3 from "../../../app/assets/images/mob&design dev-media/icon3.png";
import icon4 from "../../../app/assets/images/mob&design dev-media/icon4.png";
import icon5 from "../../../app/assets/images/mob&design dev-media/icon5.png";
import icon6 from "../../../app/assets/images/mob&design dev-media/icon6.png";
import icon7 from "../../../app/assets/images/mob&design dev-media/icon7.png";
import icon8 from "../../../app/assets/images/mob&design dev-media/icon8.png";
import icon9 from "../../../app/assets/images/mob&design dev-media/icon9.png";
import icon10 from "../../../app/assets/images/mob&design dev-media/icon10.png";
import icon11 from "../../../app/assets/images/mob&design dev-media/icon11.png";

// certificates imports

import ctf1 from "../../../app/assets/images/mob&design dev-media/ctf1.png";
import ctf2 from "../../../app/assets/images/mob&design dev-media/ctf3.png";
import ctf3 from "../../../app/assets/images/mob&design dev-media/ctf3.png";

// tech imports

import tech1 from "../../../app/assets/images/mob&design dev-media/tech1.png";
import tech2 from "../../../app/assets/images/mob&design dev-media/tech2.png";

const Products = () => {
  // useEffect(() => {
  //   // Automatically open the modal when the page loads
  //   const modalElement = document.getElementById('exampleModal');
  //   const modalInstance = new window.bootstrap.Modal(modalElement);
  //   if (modalInstance) {
  //     modalInstance.show();
  //   }
  // }, []);

  const [showModal, setShowModal] = React.useState(false);

  const closeModal = () => setShowModal(false);

  const [countryCode, setCountryCode] = useState("");

  useEffect(() => {
    // Fetch the user's country based on their IP
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        // ipapi returns the country code in ISO Alpha-2 format, which react-phone-input-2 expects
        const countryCode = response.data.country_code.toLowerCase();
        setCountryCode(countryCode);
      })
      .catch((error) => {
        console.error("Error fetching IP information:", error);
        // Optionally set a default or handle the error
      });
  }, []);

  useEffect(() => {
    // Function to open and then automatically close the modal
    const openModal = () => {
      const modalElement = document.getElementById("exampleModal");
      const modalInstance = new window.bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();

        // Set a timeout to close the modal after 10 seconds
        setTimeout(() => {
          modalInstance.hide();
        }, 10000); // 10000 milliseconds = 10 seconds
      }
    };

    // Set a timeout to open the modal after 50 seconds
    const timer = setTimeout(openModal, 500); // 50000 milliseconds = 50 seconds

    // Clean up the timers when the component is unmounted or re-rendered
    return () => clearTimeout(timer);
  }, []);

  const properties = {
    prevArrow: (
      <button className="cs-btn btn-left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-arrow-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
          />
        </svg>
      </button>
    ),
    nextArrow: (
      <button className="cs-btn btn-right">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-arrow-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
          />
        </svg>
      </button>
    ),
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const formValidationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "Minimum 3 characters")
      .matches(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/, "Should be in A-Z, a-z letters")
      .required("Please enter your name"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please enter your email address"),
    phone: Yup.string()
      .required("Please enter phone number")
      .matches(/^\d+$/, "Please enter a valid phone number")
      .min(10, "Phone number must be at least 10 digits")
      .max(15, "Phone number must not exceed 15 digits"),
    company: Yup.string()
      .min(3, "Company name must be at least 3 characters")
      .required("Please enter your Company name"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      company: "",
      downloadUrl:
        "https://capdigi.tech/2024/capdigisoft/v1/capbackend/freedownloadbooks/resource/mobile-app-and-software-development.pdf",
      bookname: "The Outbound Prospecting Playbook",
    },
    validationSchema: formValidationSchema,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const response = await axios.post(
          "https://capdigi.tech/2024/capdigisoft/v1/capbackend/submit_download.php",
          {
            mode: "adddownload_data",
            ...values,
          }
        );

        if (response.status === 200) {
          formik.resetForm();
          window.open(values.downloadUrl, "_blank");
          navigate("/thankyoudownload", {
            state: { downloadUrl: values.downloadUrl },
          });
        } else {
          console.error("Error submitting form data");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <div className="mobile-software_development-page">
      <HeaderDark />
      <section className="d-flex align-items-center justify-content-center banner-sec overflow-hidden software-sec text-center text-lg-start position-relative section-padding margin-minus">
        <div className="bg-overlay"></div>
        <div className="container custom-cn-width position-relative z-index-1 pt-5">
          <div className="row align-items-center g-lg-5 g-4 justify-content-center justify-content-lg-start">
            <div className="col-lg-9 col-md-9 mb-4 pe-lg-5">
              <h2 className="text-uppercas">
                Custom Software and Mobile App Development to Solve Any Business
                Challenge
              </h2>
            </div>
          </div>
          <div className="row align-items-center g-4 justify-content-lg-between justify-content-center">
            <div className="col-lg-5 pe-lg-5 col-md-9">
              <p className="">
                Some business challenges don’t have an “off-the shelf” software
                solution, or require a custom-built solution to tackle complex
                problems. This area of mobile app and software development is
                where CAP Digisoft excels. We’ve developed hundreds of custom
                software applications for organizations from startups to Fortune
                500 companies and have established an ISO-certified project
                management system that carefully captures every client
                requirement, and finds the right technology for your needs.
              </p>
            </div>
            <div className="col-lg-6 col-md-9">
              <video className="w-100" loop="true" autoplay="true" muted="">
                <source src={banner} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </section>

      <section className="text-center text-xl-start section-padding">
        <div className="container custom-cn-width">
          <div className="row g-4 justify-content-center text-center">
            <div className="col-lg-12 mb-4 mb-lg-5">
              <h1 className="fw-light px-4 px-md-0">
                The Right Tools for the Right Job
              </h1>
            </div>
          </div>
          <div className="row g-4 gy-xl-0 justify-content-center align-items-center position-relative z-index-1">
            <div className="col-xl-6 col-lg-7 col-md-9 order-2 order-xl-1">
              <video className="w-100" loop="true" autoplay="true" muted="">
                <source src={cutout1} type="video/mp4" />
              </video>
            </div>
            <div className="col-xl-6 col-lg-7 col-md-9 order-1 order-xl-2">
              <div className="design-block sec-title b-r-6 position-relative z-index-1">
                <p>
                  CAP Digisoft has over 18 years of experience partnering with
                  businesses and organization to build software solutions that
                  solve complex problems. We work closely with your IT staff to
                  make sure we follow internal policies and processes so that
                  our software solutions can be effectively implemented.
                </p>
                <p className="mt-3 mb-3">
                  CDS’ agile team is capable of handling projects large or
                  small, and are highly skilled in development tools including
                  PHP, Python, JQuery, Ajax, Javascript, MySQL, MSSQL, and
                  MongoDB. We also have over a decade of experience developing
                  for e-Commerce tools like Magento, Joomla Virtu Mart and Hika
                  Shop, Woocommerce, and Shopify. Our development team can also
                  work with any custom requirements or API integrations you
                  need.
                </p>
                <div className="row justify-content-center text-center g-4">
                  <div className="col-lg-4 col-6">
                    <div className="d-flex justify-content-around flex-column h-100">
                      <div>
                        <img src={ctf1} alt="" className="img-fluid" />
                      </div>
                      <div>
                        <h6 className="mt-1 f-13">
                          ISO 9001:2015 Certified Company
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-6">
                    <div className="d-flex justify-content-around flex-column h-100">
                      <div>
                        <img src={ctf2} alt="" className="img-fluid" />
                      </div>
                      <div>
                        <h6 className="mt-2 f-13">
                          ISO 27001:2015 Certified Company
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-6">
                    <div className="d-flex justify-content-around flex-column h-100">
                      <div>
                        <img src={ctf3} alt="" className="img-fluid" />
                      </div>
                      <div>
                        <h6 className="mt-1 f-13">HIPAA Compliant</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding pt-0">
        <div className="container custom-cn-width">
          <div className="row g-5 justify-content-center text-center">
            <div className="col-lg-8 col-xl-8 col-xxl-7 col-md-9 mb-4 mb-lg-5">
              <h1 className="fw-light">CDS Supports Many Industries</h1>
              <h5 className="mt-3 fw-400">
                CAP Digisoft has developed software and mobile applications for
                hundreds of clients around the world and across a variety of
                industries, including:
              </h5>
            </div>
          </div>
          <div className="row text-center g-4">
            <div className="col-md-6 col-lg-3">
              <div className="features-item">
                <div className="icons sec-primary-ic mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img src={icon1} className="img-fluid" alt="CRM" />
                </div>
                <h4>CRM</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="features-item">
                <div className="icons mb-4 sec-primary-ic d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img src={icon2} className="img-fluid" alt="CRM" />
                </div>
                <h4>Document Management</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="features-item">
                <div className="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img src={icon3} className="img-fluid" alt="CRM" />
                </div>
                <h4>Healthcare</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="features-item">
                <div className="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img src={icon4} className="img-fluid" alt="CRM" />
                </div>
                <h4>E-Commerce</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="features-item">
                <div className="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img src={icon5} className="img-fluid" alt="CRM" />
                </div>
                <h4>Legal</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="features-item">
                <div className="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img src={icon6} className="img-fluid" alt="CRM" />
                </div>
                <h4>Mobile Commerce</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="features-item">
                <div className="icons sec-primary-ic mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img src={icon7} className="img-fluid" alt="CRM" />
                </div>
                <h4>Energy Industry</h4>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="features-item">
                <div className="icons mb-4 sec-primary-ic d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img src={icon8} className="img-fluid" alt="CRM" />
                </div>
                <h4>Real Estate</h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="inner-client-sec bg-light-blue section-padding">
        <div className="container custom-cn-width">
          <div className="row align-items-center g-xl-5 g-4 justify-content-center">
            <div className="col-lg-10">
              <h1 className="fw-400">
                <i className="fa fa-quote-left me-2"></i>It was my first
                outsourcing project, as I was looking for a dedicated team to
                build a CRM to manage our employees and clients. With a highly
                technical and dedicated team, CAP DIGISOFT made it possible
                within the committed deadline. Know what? With simple and
                attractive UI, my users are finding it easy and quick to adapt,
                my software is easy to customize and maintain. I strongly
                recommend CAP DIGISOFT team and look forward to collaborate
                again for the future endeavors.
                <i className="fa fa-quote-right ms-2"></i>
              </h1>
              <h4 className="fw-400 mt-4 pt-lg-3">
                - Vice President, SAP Based Company
              </h4>
            </div>
          </div>
        </div>
      </section>

      <section className="clients section-padding">
        <div className="container custom-cn-width">
          <div className="row g-xl-5 g-4 align-items-center justify-content-center text-center">
            <div className="col-12 col-lg-9">
              <p>
                Our cost-effective global resources bring the highest quality
                development standards at competitive pricing without the need to
                make any compromises. We are sensitive to intellectual property
                and IP rights, and access to critical IP is carefully managed
                and protected within our work environment, easily able to meet
                any security requirements you have.
              </p>
            </div>
            <div className="col-12">
              <img
                src={tech1}
                alt="Tools &amp; technologies"
                className="img-fluid d-none d-md-block"
              />
              <img
                src={tech2}
                alt="Tools &amp; technologies"
                className="img-fluid d-md-none px-4"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pt-0 text-center section-padding">
        <div className="container custom-cn-width">
          <div className="row g-xl-5 g-4 justify-content-center">
            <div className="col-xxl-9 col-xl-10 col-lg-11 mb-lg-5 mb-4">
              <h2 className="fw-light">
                We develop and support apps for Android, iOS, and Windows and
                ensure that your applications run smoothly.
              </h2>
            </div>
          </div>
          <div className="row g-xl-5 g-4 justify-content-center">
            <div className="col-md-6 col-lg-4">
              <div className="features-item h-100 justify-content-start">
                <div className="icons sec-primary-ic mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img
                    src={icon9}
                    className="img-fluid"
                    alt="Native App Development"
                  />
                </div>
                <h4>Native App Development</h4>
                <p className="mt-3">
                  Our team of expert developers build native apps for both iOS
                  and Android devices, all utilizing the latest UI/UX best
                  practices, strong security features, and aligned with your
                  brand.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="features-item h-100 justify-content-start">
                <div className="icons mb-4 sec-primary-ic d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img
                    src={icon10}
                    className="img-fluid"
                    alt="Native App Development"
                  />
                </div>
                <h4>Hybrid App Development</h4>
                <p className="mt-3">
                  Our development expertise extends into Hybrid application
                  development, which combines aspects of both native and web app
                  techniques and technologies.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <div className="features-item h-100 justify-content-start">
                <div className="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img
                    src={icon11}
                    className="img-fluid"
                    alt="Native App Development"
                  />
                </div>
                <h4>Web App Development</h4>
                <p className="mt-3">
                  Progressive web applications can deliver a near-native user
                  experience with the added benefit of reaching an
                  anytime/anywhere user base through a single build.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="p-0 text-center text-lg-start">
        <div className="container custom-cn-width">
          <div className="cta-block cta-blue b-r-6">
            <div className="row g-xl-5 g-4 align-items-center justify-content-center">
              <div className="col-lg-9">
                <h2 className="fw-light text-white">
                  Custom software and mobile application development tailored to
                  solve your complex business challenges and complex problems.{" "}
                </h2>
              </div>
              <div className="col-lg-3 text-lg-end">
                <a
                  href="javascript:;"
                  className="default-btn solution_class_popu"
                  data-bs-toggle="modal"
                  data-bs-target="#meeting"
                  form_title="Mobile &amp; Software Development"
                >
                  Let's Talk
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="text-center client-block section-padding">
        <div className="container">
          <div className="row g-lg-5 g-4 justify-content-center">
            <div className="col-lg-12 mb-4 mb-lg-5">
              <h1 className="px-lg-4 ">
                Trusted by more than{" "}
                <span className="text-theme fw-bold text-grad">3000+</span>{" "}
                clients globally
              </h1>
            </div>
          </div>
          <Slide
            className="brand-slider"
            {...properties}
            slidesToScroll={1}
            slidesToShow={4}
            indicators={false}
            autoplay={true}
          >
            <div className="each-slide-effect">
              <img src={c1} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c2} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c3} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c4} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c5} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c6} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c7} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c8} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c9} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c10} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c11} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c12} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c13} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c14} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c15} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c16} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c17} alt="Logo" className="img-fluid mb-1" />
            </div>

            <div className="each-slide-effect">
              <img src={c19} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c20} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c21} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c22} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c23} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c24} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c25} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c26} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c27} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c28} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c29} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c30} alt="Logo" className="img-fluid mb-1" />
            </div>
            <div className="each-slide-effect">
              <img src={c31} alt="Logo" className="img-fluid mb-1" />
            </div>
          </Slide>
        </div>
      </section>

      <section className="other-sec pt-0 section-padding">
        <div className="container custom-cn-width">
          <div className="row g-5 text-center">
            <div className="col-lg-12 mb-lg-5 mb-4">
              <h1 className="fw-light">Other Solutions</h1>
            </div>
          </div>
          <div className="">
            <div className="row g-4 g-xl-5 text-center text-xl-start">
              <div className="col-lg-4 col-md-6">
                <fieldset className="transition">
                  <legend className="text-xl-start">Website Design</legend>
                  <div className="d-flex flex-column justify-content-between h-100">
                    <h4 className="transition mb-2 mb-lg-3">
                      Comprehensive Website Design
                    </h4>
                    <a
                      className="d-inline-block underline-border"
                      href="comprehensive-website-design"
                    >
                      <span className="border-line d-inline-block me-1">
                        Learn more
                      </span>
                      <i className="fa fa-arrow-right fa-sm position-relative"></i>
                    </a>
                  </div>
                </fieldset>
              </div>
              <div className="col-lg-4 col-md-6">
                <fieldset className="transition">
                  <legend className="text-xl-start">KPO</legend>
                  <div className="d-flex flex-column justify-content-between h-100">
                    <h4 className="transition mb-2 mb-lg-3">
                      Knowledge Process Outsourcing
                    </h4>
                    <a
                      className="d-inline-block underline-border"
                      href="knowledge-process-outsourcing"
                    >
                      <span className="border-line d-inline-block me-1">
                        Learn more
                      </span>
                      <i className="fa fa-arrow-right fa-sm position-relative"></i>
                    </a>
                  </div>
                </fieldset>
              </div>
              <div className="col-lg-4 col-md-6">
                <fieldset className="transition">
                  <legend className="text-xl-start">call center</legend>
                  <div className="d-flex flex-column justify-content-between h-100">
                    <h4 className="transition mb-2 mb-lg-3">
                      Nearshore Call Center Outsourcing
                    </h4>
                    <a
                      className="d-inline-block underline-border"
                      href="nearshore-call-center-outsourcing"
                    >
                      <span className="border-line d-inline-block me-1">
                        Learn more
                      </span>
                      <i className="fa fa-arrow-right fa-sm position-relative"></i>
                    </a>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="trigger-once">
    <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      Launch demo modal
    </button>
  </div> */}
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content p-3 resourse-bg">
            <div className="overlay-light"></div>
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="container mb-lg-5 pb-lg-5">
                <div className="row justify-content-center g-lg-5 g-4 align-items-center">
                  <div className="col-xl-12 text-center mb-3 mb-lg-4 pb-lg-3">
                    <h1 className="text-white mb-3 text-uppercase">
                      Free Downloads
                    </h1>
                    <h4 className="mb-3 px-2 p-1 d-inline-block bg-yellow1">
                      Download your book here for FREE
                    </h4>
                    <h4 className="text-white fw-600">
                      <i>Mobile App and Software Development</i>
                    </h4>
                  </div>

                  <div className="col-xl-3 col-lg-4 col-md-5 d-md-flex d-none">
                    <div>
                      <img src={book} alt="" className="img-fluid" />
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-5 col-md-7 mb-lg-2">
                    <form onSubmit={formik.handleSubmit}>
                      {/* Name field */}
                      <div className="mb-4">
                        <label
                          htmlFor="name"
                          className="form-label text-white text-white"
                        >
                          Full Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.name}
                        />
                        {formik.touched.name && formik.errors.name ? (
                          <div className="text-danger">
                            {formik.errors.name}
                          </div>
                        ) : null}
                      </div>

                      {/* Email field */}
                      <div className="mb-4">
                        <label
                          htmlFor="email"
                          className="form-label text-white text-white"
                        >
                          Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email}
                        />
                        {formik.touched.email && formik.errors.email ? (
                          <div className="text-danger">
                            {formik.errors.email}
                          </div>
                        ) : null}
                      </div>

                      {/* Phone field */}
                      <div className="mb-4">
                        <label
                          htmlFor="phone"
                          className="form-label text-white"
                        >
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <PhoneInput
                          country={countryCode}
                          value={formik.values.phone}
                          onChange={(phone) =>
                            formik.setFieldValue("phone", phone)
                          }
                        />
                        {formik.touched.phone && formik.errors.phone ? (
                          <div className="text-danger">
                            {formik.errors.phone}
                          </div>
                        ) : null}
                      </div>

                      {/* Company field */}
                      <div className="mb-4">
                        <label
                          htmlFor="company"
                          className="form-label text-white"
                        >
                          Company Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="company"
                          name="company"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.company}
                        />
                        {formik.touched.company && formik.errors.company ? (
                          <div className="text-danger">
                            {formik.errors.company}
                          </div>
                        ) : null}
                      </div>

                      <button
                        type="submit"
                        className="btn cust-btn-primary"
                        disabled={isSubmitting}
                      >
                        Send Message
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterOne />
    </div>
  );
};

export default Products;
